import { LAYOUTS, } from "@voltmoney/types";
import { IconSizeTokens, SizeTypeTokens, VerificationCardButtonTypeToken, VerificationCardTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION, } from "./types";
import { verifyPledging } from "./actions";
export const template = {
    layout: {
        id: ROUTE.PLEDGE_LOADING,
        type: LAYOUTS.MODAL,
        widgets: [
            { id: "space1", type: WIDGET.SPACE },
            { id: "alert", type: WIDGET.VERIFICATIONCARD },
            //  { id: "stack", type: WIDGET.STACK },
        ],
    },
    datastore: {
        space1: { size: SizeTypeTokens.SM },
        alert: {
            label: 'Pledging...',
            message: 'We’re fetching data from MF depositaries',
            type: VerificationCardTypeTokens.Default,
            icon: {
                name: "Volt",
                size: IconSizeTokens.XXXXXL
            },
            baseIcon: {
                name: "Rectangle",
                size: IconSizeTokens.XXXXXL
            },
            buttonType: VerificationCardButtonTypeToken.FULL,
            // action: '',
        },
    },
};
export const pledgeLoadingMF = {
    onLoad: async () => Promise.resolve(template),
    actions: {
        [ACTION.PLEDGE_VERIFY]: verifyPledging,
    },
};
